import axios from 'axios'
import Pizzip from 'pizzip'
import Docxtemplater from 'docxtemplater'
import saveAs from 'file-saver'

export async function downloadWord (templateUrl, data, name) {
  const resp = await axios.get(templateUrl, { responseType: 'arraybuffer' })
  const zip = new Pizzip(resp.data)
  const doc = new Docxtemplater().loadZip(zip)
  doc.setData(data)
  doc.render()
  const out = doc.getZip().generate({
    type: 'blob',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  })
  saveAs(out, name)
  return out
}
